import { Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./widget-library.scss";
import DraggableWidgetItem from "./draggable-widget-item";
import { WidgetLibraryItem } from "../../../utils/util-types";


interface WidgetLibraryDrawerInterface {
  isOpen: boolean;
  widgetLibraryItemList: WidgetLibraryItem[];
  closeDrawer: () => void;
  onAddClick: (value: WidgetLibraryItem)=> void;
  onRemoveClick: (value: WidgetLibraryItem)=> void;
}

export default function WidgetLibraryDrawer({
  isOpen,
  closeDrawer,
  widgetLibraryItemList,
  onAddClick, 
  onRemoveClick
}: WidgetLibraryDrawerInterface) {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={closeDrawer}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "transparent",
          },
        },
        paper: {
          sx: {
            width: "340px",
          },
        },
      }}
    >
      <div className="widget-library">
        {/* Header */}
        <div className="widget-library__header">
          <div>
            <h2>Widget Library</h2>
            <p>Add widgets to your dashboard</p>
          </div>

          <button className="icon-btn">
            <CloseIcon onClick={closeDrawer} />
          </button>
        </div>

        {/* Widget List */}
        <div className="widget-list">
          {widgetLibraryItemList.map((widgetItem, index) => (
            <DraggableWidgetItem key={widgetItem.id} widget={widgetItem} onAddClick={onAddClick} onRemoveClick={onRemoveClick} />
          ))}
        </div>
      </div>

      {/* {widgets.map((widget) => (
        <WidgetItem key={widget.id} widget={widget} />
      ))} */}
    </Drawer>
  );
}
